const mobileCtaMedia = window.matchMedia("(max-width: 600px)");

function getMobileCtaItem(navList) {
  return Array.from(navList.children).find((item) =>
    item.classList.contains("header-cta-button--mobile")
  );
}

function createMobileCtaItem(headerCta) {
  const ctaContent = headerCta.querySelector("p");

  if (!ctaContent) {
    return null;
  }

  const mobileCtaItem = document.createElement("li");
  mobileCtaItem.className =
    "wp-block-navigation-item wp-block-navigation-link header-cta-button header-cta-button--mobile";
  mobileCtaItem.appendChild(ctaContent.cloneNode(true));

  return mobileCtaItem;
}

function syncHeaderMobileCta() {
  const headerCta = document.querySelector(
    ".header__container > .header-cta-button:not(.header-cta-button--mobile)"
  );
  const navList = document.querySelector(
    ".wp-block-navigation__responsive-container-content > .wp-block-navigation__container"
  );

  if (!headerCta || !navList) {
    return;
  }

  const currentMobileCta = getMobileCtaItem(navList);

  if (!mobileCtaMedia.matches) {
    if (currentMobileCta) {
      currentMobileCta.remove();
    }

    return;
  }

  if (!currentMobileCta) {
    const mobileCtaItem = createMobileCtaItem(headerCta);

    if (mobileCtaItem) {
      navList.appendChild(mobileCtaItem);
    }
  }
}

export default function initHeaderMobileCta() {
  syncHeaderMobileCta();

  if (typeof mobileCtaMedia.addEventListener === "function") {
    mobileCtaMedia.addEventListener("change", syncHeaderMobileCta);
  } else {
    mobileCtaMedia.addListener(syncHeaderMobileCta);
  }
}
